angular.module('unergie.main')
.controller('newPceCtrl', ($q, $rootScope, $scope, $state, $stateParams, $filter, ReferencesService, ApiUser, DataAccess, ProDrafts, AlertManager, CommonRegex, OrganizationService,
    ErrorCatcher, ModalService, BoFeaturesService) => {
    $scope.handleServiceOrder = false

    $scope.nameRegex = CommonRegex.fullname
    $scope.phoneRegex = CommonRegex.phone.french

    $scope.pceOk = undefined

    $scope.recap = {}

    $scope.contact = {}

    $scope.showTools = !BoFeaturesService.get('isEnvProd')

    $scope.managedAccount = undefined
    $scope.chosenManagedAccount = undefined

    OrganizationService.getServiceOrderOrgz().then((serviceOrderOrgz) => {
        $scope.serviceOrderOrgz = serviceOrderOrgz
    })

    $scope.seachAccount = ''
    $scope.selectAccount = (acc) => {
        $scope.managedAccount = acc
    }

    $scope.chooseManagedAccount = () => {
        $scope.chosenManagedAccount = $scope.managedAccount
        if ($scope.chosenManagedAccount) {
            $scope.seachAccount = $scope.chosenManagedAccount.name
            $scope.handleServiceOrder = $scope.serviceOrderOrgz.includes($scope.chosenManagedAccount.organization)
            $scope.loadContacts()
            return $scope.refreshCategories()
        }
    }

    $scope.searchCategory = ''
    $scope.selectCategory = (cat) => {
        return ProDrafts.initDraft({ id_account: $scope.chosenManagedAccount.id_account, id_category: cat.id, energy_type: 'GAS' }).$promise.then((draft) => {
            $scope.draft = draft
            $scope.searchCategory = _.find($scope.categories, { id: $scope.draft.id_category }).name
            $state.go($state.current, { id_draft: draft.id }, { notify: false })
        })
        .catch(ErrorCatcher)
    }

    $scope.draft = {}

    $rootScope.$on('pceSelected', (e, idPce) => {
        $scope.draft.draftGas.id_pce = idPce
        $scope.pceChanged()
    })

    $scope.pceInputClass = function () {
        if ($scope.pceOk === undefined) {
            return ''
        } else if ($scope.pceOk) { return 'has-success' } return 'has-error'
    }

    // DATE FIELD
    $scope.desired_mes_date = moment().format('DDMMYYYY')

    $scope.updateDateTemplate = () => {
        $scope.draft.desired_mes_date = moment($scope.desired_mes_date, 'DDMMYYYY').toDate()
    }

    // EXISTING CONTACTS
    $scope.loadContacts = function () {
        if (!$scope.existingContacts) {
            DataAccess.getAdditionalContacts({ type: 'TECHNICAL', id_account: $scope.chosenManagedAccount.id_account }).$promise.then((contacts) => {
                $scope.existingContacts = contacts
            }).catch(ErrorCatcher)
        }
        if ($scope.handleServiceOrder && !$scope.existingRequester) {
            DataAccess.getAdditionalContacts({ type: 'REQUESTER_COMMISSION', id_account: $scope.chosenManagedAccount.id_account }).$promise.then((contacts) => {
                $scope.existingRequester = contacts
            }).catch(ErrorCatcher)
        }
    }

    $scope.updateContact = function (contact) {
        $scope.contact = _.pick(contact, ['civ', 'sn', 'givenname', 'phone', 'email'])
    }

    $scope.updateRequester = function (requester) {
        $scope.requester = _.pick(requester, ['civ', 'sn', 'givenname'])
    }

    // DRAFT
    $scope.resetDraft = function () {
        $scope.draft = null
        $scope.seachAccount = ''
        $scope.searchCategory = ''
        $scope.managedAccount = undefined
        $scope.chosenManagedAccount = undefined
        $scope.popupImportTemplate = {}
        $scope.simulationResult = undefined
        $scope.pceResult = undefined
        $scope.pceOk = undefined
        $state.go($state.current, { id_draft: null }, { notify: false })
    }

    // PRM
    $scope.eligibilityPce = function () {
        $scope.pceChanged()
        $scope.fetching = true
        $scope.pceOk = false
        return ProDrafts.eligibilityPce({ id_pce: $scope.draft.draftGas.id_pce, id_draft_basic: $scope.draft.id, id_contract_gas: $scope.draft.draftGas.id }).$promise.then((pce) => {
            $scope.pceResult = pce.toJSON()
            if (pce.eligible) {
                if (pce.duplicates) {
                    $scope.pceResult.message = `Le point que vous essayez d'ajouter est déjà` +
                        ` dans le périmètre de ${pce.duplicates[0].owner} au status "${$filter('contractStatus')(pce.duplicates[0].status)}"`
                }
                $scope.pceOk = true
            }
        }).catch((error) => {
            $scope.pceResult = error
            $scope.pceOk = false
            ErrorCatcher(error)
        }).finally(() => {
            $scope.fetching = false
        })
    }

    $scope.pceChanged = function () {
        $scope.pceResult = undefined
        $scope.pceOk = false
    }

    // PRM SEARCH
    $scope.searchPrm = () =>
        ModalService.openModal({ type: 'pceSearchModal', size: 'xlg' }, { light: false }, (result) => {
            $scope.draft.id_pce = result
            if ($scope.draft.id_pce.length === 14) {
                return $scope.eligibilityPce()
            }
        })

    // AFFECTED ACCOUNTS
    DataAccess.myAffectations().$promise.then((affectations) => {
        $scope.affectedAccounts = affectations
        if ($stateParams.id_account) {
            $scope.managedAccount = _.find($scope.affectedAccounts, { id_account: $stateParams.id_account })
            $scope.chooseManagedAccount()
        }
        if ($stateParams.id_draft) {
            return ProDrafts.getDraft({ id_draft_basic: $stateParams.id_draft }).$promise.then((draft) => {
                $scope.draft = draft
                $scope.managedAccount = _.find($scope.affectedAccounts, { id_account: $scope.draft.id_account })
                $scope.chooseManagedAccount().then(() => {
                    $scope.searchCategory = _.find($scope.categories, { id: $scope.draft.id_category }).name
                })
            })
        }
    }).catch(ErrorCatcher)

    // CATEGORIES
    $scope.refreshCategories = () => {
        $scope.refreshingCategories = true
        return DataAccess.getRefContractCategories({ id_account: $scope.chosenManagedAccount.id_account, energy_type: 'GAS' }).$promise.then((categories) => {
            $scope.categories = categories
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingCategories = false
        })
    }

    // TRANSFORM
    $scope.generateRecap = function () {
        const label = `${$scope.handleServiceOrder ? `Demandeur : <b>${$scope.requester.civ} ${$scope.requester.givenname} ${$scope.requester.sn}</b><br>` : ''}` +
            `Compte : <b>${$scope.chosenManagedAccount.name}</b><br>` +
            `Regroupement : <b>${_.find($scope.categories, { id: $scope.draft.id_category }).name}</b><br>` +
            `PCE : <b>${$scope.draft.draftGas.id_pce}</b><br>` +
            `Adresse : <b>${$scope.draft.addr_num_street}</b><br>` +
            `CP : <b>${$scope.draft.addr_post_code}</b><br>` +
            `Libellé : <b>${$scope.draft.label || '- Pas de libellé -'}</b><br>` +
            `Date MES : <b>${moment($scope.draft.desired_mes_date).format('DD MMM YYYY')}</b><br>` +
            `Contact : <b>${$scope.contact.civ} ${$scope.contact.givenname} ${$scope.contact.sn}</b><br>` +
            `<b>(${$scope.contact.phone})</b><br>` +
            `<b>${$scope.contact.email}</b><br>`
        $scope.recap = {
            expl: {
                label,
                type: 'label',
            },
        }
    }

    $scope.canAddPce = () => {
        return !!$scope.draft &&
            !!$scope.draft.id_category &&
            !!$scope.contact.civ &&
            !!$scope.contact.givenname &&
            !!$scope.contact.sn &&
            !!$scope.contact.phone &&
            !!$scope.contact.email &&
            !!$scope.draft.label &&
            (!$scope.handleServiceOrder || (
                !!$scope.requester.civ &&
                !!$scope.requester.givenname &&
                !!$scope.requester.sn
            ))
    }

    $scope.openNewCategoryModal = () => {
        ModalService.openModal({ type: 'editCategoryModal', size: 'xlg', backdrop: 'static' }, { category: null, id_account: $scope.chosenManagedAccount.id_account },
            (result) => {
                $scope.refreshCategories().then(() => {
                    if (result) {
                        $scope.selectCategory({ id: result })
                    }
                })
            })
    }

    $scope.addPce = function () {
        let ok = false
        const payload = {
            technicalContact: $scope.contact,
            requester: $scope.requester,
        }
        $scope.addingPce = true
        return ProDrafts.updateDraft({ id_draft_basic: $scope.draft.id }, $scope.draft).$promise
        .then(() =>
            ProDrafts.transformDraft({ id_draft_basic: $scope.draft.id }, payload).$promise.then(() => {
                AlertManager.success('PCE ajouté avec succès')
                ok = true
            }))
        .catch(ErrorCatcher)
        .then(() => {
            // stupid trick to avoid "transition prevented"
            if (ok) {
                return $state.go('pces', { pce: $scope.draft.id_pce, activate: true })
            }
        })
        .finally(() => {
            $scope.addingPce = false
        })
    }
})
